export default "__VITE_ASSET__DpfU9rCu__"